<template>
  <div id="home">
    <iframe
      :src="responseURL"
      frameborder="0"
      :style="{ zIndex: zIndex }"
    ></iframe>
    <div class="content">
      <img class="cover" src="@/assets/images/cover.png" alt="" />
      <div class="login">
        <div class="title">Hi,欢迎回来</div>
        <!-- <div class="username">
          <div class="prompt">您的账号和邮箱</div>
          <input
            type="text"
            v-model="user.username"
            placeholder="请输入您的账号或邮箱"
          />
        </div>
        <div class="password">
          <div class="prompt">密码</div>
          <div class="input">
            <input
              :type="user.passwordShow ? 'text' : 'password'"
              v-model="user.password"
              placeholder="请输入您的密码"
            />
            <img
              class="eye"
              :src="
                require(`../assets/images/eye_${
                  user.passwordShow ? 'on' : 'off'
                }.png`)
              "
              @click="user.passwordShow = !user.passwordShow"
            />
          </div>
        </div> -->
        <!-- <div class="loginBtn" @click="login">登录</div> -->
        <a class="loginBtn" href="./login.html">登录</a>
        <!-- <div class="register">
          <img src="@/assets/images/headImg.png" alt="" />
          <div class="goRregister">
            <div class="prompt">还没有账号？</div>
            <a href="javascript:;">立即注册</a>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      responseURL: "",
      zIndex: "-1",
      user: {
        username: "",
        password: "",
        passwordShow: false,
        eyeSrc: require("../assets/images/eye_off.png"),
      },
    };
  },
  mounted() {
    if (window.innerWidth <= 1440 || window.innerHeight <= 840) {
      const el = document.querySelector("#home");
      el.style.justifyContent = "flex-start";
      el.style.alignItems = "flex-start";
    }
  },
};
</script>

<style lang="scss" scoped>
#home {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: #f5f5f5;
  iframe {
    position: absolute;
    left: 0;
    right: 0;
    width: 100vw;
    height: 100vh;
  }
  .content {
    display: flex;
    // justify-content: center;
    align-items: center;
    width: 1440px;
    height: 840px;
    background-color: #fff;
  }
  .cover {
    height: 840px;
    border-right: 1px solid rgb(231, 231, 231);
    // margin-top: 120px;
  }
  .login {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 268px 0 auto 130px;
    // margin: 235px 0 0 80px;
    height: fit-content;
    .title {
      font-size: 64px;
      margin-bottom: 60px;
    }
    .username {
      margin-bottom: 30px;
    }
    .username,
    .password {
      .prompt {
        font-size: 16px;
        color: rgba(63, 63, 68, 1);
        margin-bottom: 6px;
      }
      input {
        width: 341px;
        height: 50px;
        padding-left: 24px;
        border: none;
        line-height: 50px;
        border-radius: 8px;
        background-color: rgba(247, 247, 247, 1);
      }
      .input {
        position: relative;
        .eye {
          position: absolute;
          top: 50%;
          right: 10px;
          transform: translate(-50%, -50%);
          cursor: pointer;
        }
      }
    }
    .loginBtn {
      width: 240px;
      // width: 365px;
      height: 50px;
      border: none;
      line-height: 50px;
      border-radius: 8px;
      // margin-top: 28px;
      background-color: #fdcb9e;
      text-align: center;
      color: rgba(63, 63, 68, 1);
      text-decoration: none;
    }
    .register {
      display: flex;
      align-items: center;
      margin-top: 166px;
      img {
        width: 180px;
        margin-right: 30px;
      }
      a {
        color: rgb(253, 203, 158);
      }
    }
  }
}
</style>